// extracted by mini-css-extract-plugin
module.exports = {"root":"CustomTip_root__2uSRx","inputWrap":"CustomTip_inputWrap__16gWY"};